import script from "./GanttChartBar.vue?vue&type=script&setup=true&lang=js"
export * from "./GanttChartBar.vue?vue&type=script&setup=true&lang=js"

import "./GanttChartBar.vue?vue&type=style&index=0&id=7cb0a7d4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb0a7d4"]])

export default __exports__